import { Injectable } from '@angular/core';
import { AppConfigService } from './appConfig.service';

@Injectable()
export class ThirdpartyGamesServices {
    constructor(private configService: AppConfigService) {}

    launchGame(data = {}, keyLaunch: string, nav: any) {
        data['flag'] = `GameLaunch_${keyLaunch}`;
        return this.configService.gameThirdParty(data, nav);
    }
    balanceThirdPartyGame(data = {}, keyLaunch: string, nav: any) {
        data['flag'] = `CheckBalance_${keyLaunch}`;
        return this.configService.gameThirdParty(data, nav);
    }
    transferBalance(data = {}, keyLaunch: string, nav: any) {
        data['flag'] = `FundTransfer_${keyLaunch}`;
        return this.configService.gameThirdParty(data, nav);
    }
    gameList(data = {},nav: any) {
        data['flag'] = `GameList`;
        return this.configService.gameThirdParty(data, nav);
    }
    transferInit(data = {},nav: any) {
        data['flag'] = `Transfer_init`;
        return this.configService.gameThirdParty(data, nav);
    }
}



// WEBPACK FOOTER //
// ./src/services/thirdGame.services.ts